import { Link } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { LEGAL_DOCUMENTS, openLegalDocument } from '../lib/externalLinks';

/** In-app link to a legal document: the web route on web, the hosted PDF in an in-app browser on iOS. */
export default function LegalLink({ kind, className, children, onNavigate }) {
  const doc = LEGAL_DOCUMENTS[kind];
  const label = children || doc.label;

  if (Capacitor.isNativePlatform()) {
    return (
      <button
        type="button"
        className={className}
        onClick={() => {
          onNavigate?.();
          openLegalDocument(kind);
        }}
        data-testid={`legal-link-${kind}`}
      >
        {label}
      </button>
    );
  }

  return (
    <Link to={doc.route} className={className} onClick={onNavigate} data-testid={`legal-link-${kind}`}>
      {label}
    </Link>
  );
}
